import { twMerge } from 'tailwind-merge';
import Svg, { SvgProps } from './Svg';

const Dash = ({ className, ...rest }: SvgProps) => (
  <Svg viewBox="0 0 16 2" width="16" height="2" className={twMerge('stroke-none', className)} {...rest}>
    <path fillRule="evenodd" clipRule="evenodd" d="M14.4165 0.0820312C14.9228 0.0820312 15.3332 0.492437 15.3332 0.998698C15.3332 1.4688 14.9793 1.85625 14.5234 1.9092L14.4165 1.91537H1.58317C1.07691 1.91537 0.666504 1.50496 0.666504 0.998698C0.666504 0.528599 1.02037 0.14115 1.47627 0.0881983L1.58317 0.0820312H14.4165Z" fill="#002B54" />
  </Svg>
);

export default Dash;
